import { NgStyle } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  effect,
  inject,
  signal,
} from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { TranslateModule, TranslatePipe } from '@ngx-translate/core';
import { MENU_ITEMS, ThemeBaseComponent } from 'src/app/_core';
import { LangSelectorComponent } from 'src/app/_shared/components/navbar/components/lang-selector/lang-selector.component';
import { MobileMenuComponent } from 'src/app/_shared/components/navbar/components/mobile-menu/mobile-menu.component';
import { CartService } from 'src/app/routes/public/modules/cart/state/cart.service';
import { IconComponent } from '../icon/icon.component';
import { IconButtonComponent } from '../icon-button/icon-button.component';
import { WindowResizeService } from 'src/app/_core/services/window-resize.service';
import { NavbarService } from './state/navbar.service';

@Component({
  standalone: true,
  selector: 'neopos-navbar',
  templateUrl: './navbar.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    NgStyle,
    RouterLink,
    RouterLinkActive,
    TranslateModule,
    IconButtonComponent,
    IconComponent,
    LangSelectorComponent,
    MobileMenuComponent,
  ],

  providers: [TranslatePipe],
})
export class NavbarComponent extends ThemeBaseComponent {
  private readonly _windowResizeService = inject(WindowResizeService);
  private readonly _cartService = inject(CartService);
  readonly navbarService = inject(NavbarService);

  activeCart = this._cartService.activeCart;

  windowResolutionData = this._windowResizeService.windowResolutionData;

  menuOpened = signal<boolean>(false);

  readonly menuItems = MENU_ITEMS;

  constructor() {
    super();

    effect(
      () => {
        this.windowResolutionData();

        this.menuOpened.set(false);
      },
      { allowSignalWrites: true }
    );
  }
}
